/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const to_the_garage : {[key: string]: Array<[string, string]>} = {
};
